import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/video_play.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a4655f6c")

_pushScopeId("data-v-a4655f6c")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "cover-wrapper" }
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "waterfall-wrapper"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "icon",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1)
          ]),
          _createVNode(_component_HotspotContentList, {
            list: _ctx.modules.list,
            onAudiobgstop: _ctx.audiobgstop
          }, null, 8, ["list", "onAudiobgstop"]),
          (_ctx.modules.videos && _ctx.modules.videos.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.videos, (i, k) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "waterfall-item",
                    key: k,
                    onClick: _withModifiers(($event: any) => (_ctx.watchVideo(i)), ["stop","prevent"])
                  }, [
                    (i && i.poster)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: i.poster
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _hoisted_5
                  ], 8, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_van_popup, {
          round: "",
          style: _ctx.popStyle,
          show: _ctx.videoShow,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.videoShow = $event)),
          onClosed: _ctx.videoPause,
          teleport: "#app"
        }, {
          default: _withId(() => [
            _createVNode("video", {
              class: "pop-video",
              ref: "popvideo",
              src: _ctx.video,
              controls: "controls",
              preload: "",
              autoplay: "",
              "x5-playsinline": "true",
              playsinline: "true",
              "webkit-playsinline": "true",
              onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
            }, null, 40, ["src"])
          ]),
          _: 1
        }, 8, ["style", "show", "onClosed"])
      ]))
    : _createCommentVNode("", true)
})